import template from './resubmit-failed-order.html';
export var ResubmitFailedOrderComponent = {
    template: template,
    controller: /** @class */ (function () {
        function ResubmitFailedOrderComponent($scope, $rootScope, $state, $q, CreditCardService, CartService, FailedOrdersService, CommonDataService) {
            'ngInject';
            this.cardType = null;
            this.cart = null;
            this.creditCard = null;
            this.creditFormValidated = false;
            this.cvv = '';
            this.errorGettingFailedOrderData = false;
            this.errors = {
                pageErrorType: '',
                pageErrors: '',
                havePageErrors: false
            };
            this.isNewCreditCard = false;
            this.gettingFailedOrderData = null;
            this.orderId = 0;
            this.paymentType = 'Credit Card';
            this.showAlert = false;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$state = $state;
            this.$q = $q;
            this.CreditCardService = CreditCardService;
            this.CartService = CartService;
            this.FailedOrdersService = FailedOrdersService;
            this.CommonDataService = CommonDataService;
            this.isAkrisOrder = this.$state.params.isAkrisOrder;
        }
        ResubmitFailedOrderComponent.prototype.$onInit = function () {
            this.getFailedOrderCart();
        };
        ResubmitFailedOrderComponent.prototype.addPayment = function () {
            var _this = this;
            this.$rootScope.loading = true;
            this.addPaymentPromise = this.$q.defer();
            if (this.paymentType !== 'Credit Card') {
                this.CartService.addPayment({}, this.paymentType, null, this.cart.basketName)
                    .then(function (response) {
                    _this.addPaymentPromise.resolve(response);
                });
            }
            else if (this.paymentType === 'Credit Card' && this.isNewCreditCard) {
                this.CreditCardService.addCreditCard(this.creditCard)
                    .then(function (response) {
                    var selectedPayment = response;
                    _this.CartService.addPayment(selectedPayment, 'CreditCard', _this.cvv, _this.cart.basketName)
                        .then(function (response) {
                        _this.addPaymentPromise.resolve(response);
                    });
                });
            }
            else {
                if (this.creditCard.isDefaultPayment) {
                    this.CreditCardService.setDefaultCreditCard(this.creditCard.creditCardId);
                }
                this.CartService.addPayment(this.creditCard, 'CreditCard', this.cvv, this.cart.basketName)
                    .then(function (response) {
                    _this.addPaymentPromise.resolve(response);
                });
            }
            return this.addPaymentPromise.promise;
        };
        ResubmitFailedOrderComponent.prototype.cartChanged = function (_a) {
            var cart = _a.cart;
            if (!cart)
                return;
            this.cart = cart;
        };
        ResubmitFailedOrderComponent.prototype.closeAlertMessage = function () {
            this.showAlert = false;
        };
        ResubmitFailedOrderComponent.prototype.bannerMessage = function (message) {
            this.errors.pageErrorType = 'warning';
            this.errors.pageErrors = message;
            this.errors.havePageErrors = true;
            this.showAlert = true;
        };
        ResubmitFailedOrderComponent.prototype.isFormValid = function (_a) {
            var isValid = _a.isValid, creditCard = _a.creditCard, cardType = _a.cardType, cvv = _a.cvv, isNewCreditCard = _a.isNewCreditCard, paymentType = _a.paymentType;
            if (paymentType === undefined || isValid === undefined)
                return;
            if (paymentType === 'Credit Card' &&
                (creditCard === undefined || cardType === undefined ||
                    cvv === undefined || isNewCreditCard === undefined))
                return;
            this.creditFormValidated = isValid;
            this.cardType = cardType;
            this.cvv = cvv;
            this.isNewCreditCard = isNewCreditCard;
            this.paymentType = paymentType;
            if (isNewCreditCard) {
                this.creditCard = creditCard;
            }
        };
        ResubmitFailedOrderComponent.prototype.getFailedOrderCart = function () {
            var _this = this;
            this.orderId = this.$state.params.orderId;
            this.gettingFailedOrderData = this.FailedOrdersService.getFailedOrderCart(this.orderId, this.isAkrisOrder)
                .then(function (data) {
                _this.cart = data.response;
                _this.CartService.cartData = _this.cart;
            })
                .catch(function () { return _this.errorGettingFailedOrderData = true; })
                .finally(function () { return _this.gettingFailedOrderData = null; });
        };
        ResubmitFailedOrderComponent.prototype.addAkrisPayment = function () {
            var _this = this;
            this.$rootScope.loading = true;
            this.addPaymentPromise = this.$q.defer();
            if (this.paymentType === 'Credit Card' && this.isNewCreditCard) {
                this.CreditCardService.addCreditCard(this.creditCard).then(function (response) {
                    _this.addPaymentPromise.resolve({
                        paymentType: 'Credit Card',
                        creditCardId: response.creditCardId,
                        cvv: _this.cvv
                    });
                });
            }
            if (this.paymentType === 'Credit Card' && !this.isNewCreditCard) {
                this.addPaymentPromise.resolve({
                    paymentType: 'Credit Card',
                    creditCardId: this.creditCard.creditCardId,
                    cvv: this.cvv
                });
            }
            if (this.paymentType !== 'Credit Card') {
                this.addPaymentPromise.resolve({
                    paymentType: this.paymentType
                });
            }
            return this.addPaymentPromise.promise;
        };
        ResubmitFailedOrderComponent.prototype.resubmitAkrisOrder = function (payment) {
            var _this = this;
            var resubmitAkrisOrder = {
                orderId: this.$state.params.orderId,
                payment: payment,
                cvv: (payment || {}).cvv
            };
            this.CartService.submitAkrisOrder(resubmitAkrisOrder).then(function (response) {
                _this.$rootScope.loading = false;
                if (response && response.status === 200) {
                    var orderStatus = response.data.response;
                    _this.CartService.orderResult = {
                        customerPoNumber: orderStatus.customerPoNumber,
                        orderDate: orderStatus.orderDate,
                        status: orderStatus.orderStatus
                    };
                    _this.CartService.cartData = _this.cart;
                    _this.$state.go('placedOrder', { isAkrisOrder: true });
                }
            });
        };
        ResubmitFailedOrderComponent.prototype.resubmitOrderClick = function () {
            var _this = this;
            if (this.isAkrisOrder) {
                this.addAkrisPayment().then(function (payment) {
                    _this.resubmitAkrisOrder(payment);
                }).catch(function () {
                    _this.$rootScope.loading = false;
                    _this.bannerMessage('An error has occurred while adding your payment method');
                });
            }
            else {
                this.addPayment()
                    .then(function (response) {
                    if (response && response.status === 200) {
                        var holdCodes = _this.cart.holdCodes;
                        _this.cart = response.data.response;
                        _this.cart.holdCodes = holdCodes;
                        _this.resubmitOrder();
                    }
                    else {
                        _this.$rootScope.loading = false;
                        _this.bannerMessage('An error has occurred while adding your payment method');
                    }
                })
                    .catch(function () {
                    _this.$rootScope.loading = false;
                    _this.bannerMessage('An error has occurred while adding your payment method');
                });
            }
        };
        ResubmitFailedOrderComponent.prototype.resubmitOrder = function () {
            var _this = this;
            var orderOrigin;
            var source;
            if (window.location.host.split('.')[1] === 'qa') {
                orderOrigin = 'AQ';
                source = 'AQ';
            }
            else if (window.location.host.split('.')[1] === 'stage') {
                orderOrigin = 'AS';
                source = 'AS';
            }
            else {
                orderOrigin = 'I';
                source = 'I';
            }
            this.CommonDataService.orderSummaryList = true;
            this.CartService.processOrder({
                orderOrigin: orderOrigin,
                source: source,
                customerPoNumber: null,
                cvvCode: this.paymentType === 'Credit Card' ? this.cvv : null,
                failedCartName: this.cart.basketName,
                failedOrderId: this.orderId,
                holdCodes: this.cart.holdCodes
            }, this, this.cart)
                .then(function (res) {
                res = res.data.response;
                _this.orderDate = res.orderDate;
                _this.CartService.setOrderResult({
                    orderDate: res.orderDate,
                    customerPoNumber: null,
                    status: res.orderStatus || 'Pending',
                    salesOrder: null
                });
                _this.$state.go('placedOrder');
            })
                .catch(function () { return _this.bannerMessage('An error has occurred while processing your order'); })
                .finally(function () {
                _this.$rootScope.loading = false;
            });
        };
        ResubmitFailedOrderComponent.prototype.selectPayment = function (_a) {
            var creditCard = _a.creditCard;
            if (!creditCard)
                return;
            this.creditCard = creditCard;
        };
        return ResubmitFailedOrderComponent;
    }())
};
//# sourceMappingURL=resubmit-failed-order.component.js.map